<template>
<div>
  <div class="pl-table" v-if="!refreshPage">
    <div class="pl-table-head">
      <div class="pl-t-h-col">Product/Service</div>
      <div class="pl-t-h-col">Type</div>
      <div class="pl-t-h-col">Action</div>
    </div>
    <div class="pl-table-body" v-for="product in products" :key="product._id">
      <div class="pl-table-row">
      <div class="pl-t-b-col">{{ product.name }}</div>
      <div class="pl-t-b-col">Bundle</div>
      <div class="pl-t-b-col">
        <i class="fas fa-edit" @click="editProduct(product)"></i>
        <i class="ml-2 fas fa-share" @click="copyURL(product.slug)"></i>
        <i class="ml-2 fas fa-trash" @click="deleteProduct(product)"></i>
      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ProductList',
  data () {
    return {
      products: [],
      refreshPage: false
    }
  },
  watch: {
    refreshPage () {
      if (this.refreshPage) {
        setTimeout(() => {
          this.refreshPage = false
        }, 500)
      }
    }
  },
  mounted () {
    this.getBundleList()
  },
  methods: {
    async copyURL (mytext) {
      try {
        const link = `https://portal.authorizelocal.com/cart/${mytext}`
        await navigator.clipboard.writeText(link)
        alert('Copied')
      } catch ($e) {
        console.log('Cannot copy')
      }
    },
    editProduct (product) {
      this.$parent.editProduct(product)
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteProduct (item) {
      this.openConfirm(() => {
        this.$validator.validateAll().then(result => {
          if (result) {

            this.$vs.loading()

            this.$store.dispatch('deleteBundle', item._id)
              .then(response => {
                console.log('response', response)
                this.getBundleList()
                this.$vs.loading.close()
              })
              .catch(err => {
                console.error(err)
              })

          }
        })
      }, () => {})
    },
    getBundleList () {
      const payload = {
        page: 0
      }
      this.$store.dispatch('getBundleList', payload)
        .then(response => {
          console.log('getBundleList response', response)
          this.products = response.data
          this.refreshPage = true
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss">
.pl-table {
  width:100%;
}
.pl-table-head, .pl-table-row {
  width:100%;
  display:flex;
  align-items:center;
  padding:15px;
  border:1px solid #ccc;
}
.pl-table-body {
  margin-top:-1px;
}
.pl-t-h-col, .pl-t-b-col{
  width:20%;
  font-weight: 900;
  &:first-child {
    width:60%;
  }
}
.pl-t-b-col{
  font-weight: 600;
}
.pl-table-body {
width:100%;
}
.pl-table-row{
  margin-top:-1px;
  &:nth-child(even){
    background-color:#f4f8fd;
  }
  &:hover{
    cursor:pointer;
    background-color:#ebf3fd;
  }
}
</style>
